import type { ReactNode, CSSProperties } from 'react';
import { FlexBox, Title } from '@ui5/webcomponents-react';

/**
 * Page title row whose action buttons wrap underneath the title on narrow (phone) widths
 * instead of being pushed off the right edge of the screen.
 */
export function PageHeader({ title, level = 'H3', actions, style }: { title: ReactNode; level?: 'H3' | 'H4'; actions?: ReactNode; style?: CSSProperties }) {
  return (
    <FlexBox wrap="Wrap" justifyContent="SpaceBetween" alignItems="Center" style={{ gap: '0.5rem 1rem', marginBottom: '0.75rem', ...style }}>
      <Title level={level} style={{ margin: 0 }}>{title}</Title>
      {actions && <FlexBox wrap="Wrap" alignItems="Center" style={{ gap: '0.5rem' }}>{actions}</FlexBox>}
    </FlexBox>
  );
}
